const values = {};
// We get "SecurityError: The operation is insecure." if browser has disabled localStorage
const localStorageSupported = (() => {
    try {
        const storageKey = '__test__';
        localStorage.setItem(storageKey, storageKey);
        localStorage.removeItem(storageKey);
        return true;
    }
    catch (e) {
        console.error(`window.localStorage unavailable.`);
    }
    return false;
})();
const setItem = (key, value) => {
    if (localStorageSupported) {
        localStorage.setItem(key, value);
    }
    else {
        values[key] = value;
    }
};
const getItem = (key) => {
    if (localStorageSupported) {
        return localStorage.getItem(key);
    }
    else {
        return values[key];
    }
};
const removeItem = (key) => {
    if (localStorageSupported) {
        localStorage.removeItem(key);
    }
    else {
        delete values[key];
    }
};

/**
 * Generated bundle index. Do not edit.
 */

export { getItem, removeItem, setItem };
